import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';

const Services = () => {
  
  const services = [
    /*{
      title: "Golf Academy",
      description: "Personalized coaching programs with certified PGA professionals. Transform your game through systematic training and modern techniques.",
      features: [
        "Personalized coaching programs",
        "Youth development programs",
        "Professional tournament training",
        "Mental game coaching",
        "Group & private lessons",
        "Performance analysis"
      ],
      image: "https://plus.unsplash.com/premium_photo-1661362222640-c262dad02bab?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      icon: "🏌️",
      color: "#B59A5A"
    },
    {
      title: "Golf Simulators",
      description: "Cutting-edge technology with real-time swing analysis. Practice on world-class courses regardless of weather conditions.",
      features: [
        "Advanced swing analysis",
        "Virtual course play",
        "Data-driven improvement",
        "Multiplayer experiences",
        "Tournament simulation",
        "Progress tracking"
      ],
      image: "https://emvwr2994ad.exactdn.com/wp-content/uploads/2022/02/golfsimulator-stockholm.jpg?strip=all&quality=77",
      icon: "📊",
      color: "#1F3D2B"
    },
    {
      title: "Pro Shop",
      description: "Premium equipment with expert custom fitting. Find the perfect gear to enhance your performance on the course.",
      features: [
        "Custom club fitting",
        "Premium equipment",
        "Apparel & accessories",
        "Equipment maintenance",
        "Gear customization",
        "Expert consultations"
      ],
      image: "https://images.squarespace-cdn.com/content/v1/6089dcbaf5342302edc405dd/1628734033438-MQ6DRVX55NC93IVMIRJG/unsplash-image-ZnBBDPO2mbQ.jpg",
      icon: "🛒",
      color: "#B59A5A"
    },
    {
      title: "Membership Programs",
      description: "Flexible membership options designed for golfers of all levels. Access premium facilities and exclusive benefits.",
      features: [
        "Flexible membership tiers",
        "Unlimited simulator access",
        "Priority booking",
        "Member events",
        "Guest privileges",
        "Discounts on services"
      ],
      image: "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      icon: "🎯",
      color: "#1F3D2B"
    },
    {
      title: "Corporate Events",
      description: "Host memorable golf events for your team or clients. Perfect for networking, team building, and corporate entertainment.",
      features: [
        "Team building events",
        "Client entertainment",
        "Tournament organization",
        "Catering services",
        "Branding opportunities",
        "Professional photography"
      ],
      image: "https://images.unsplash.com/photo-1575361204480-aadea25e6e68?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      icon: "🏢",
      color: "#B59A5A"
    },
    {
      title: "Junior Programs",
      description: "Specialized training for young golfers. Nurture talent from an early age with age-appropriate coaching.",
      features: [
        "Age-appropriate training",
        "School partnerships",
        "Tournament preparation",
        "Scholarship opportunities",
        "Parent-child programs",
        "Summer camps"
      ],
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      icon: "👦",
      color: "#1F3D2B"
    }*/
  ];

  const technologyDetails = [
    {
      title: "Golf Simulator Technology",
      content: "Our advanced simulators feature cutting-edge technology:",
      features: [
        "High-speed cameras for precise ball tracking",
        "Infrared sensors for accurate club data",
        "4K projection for immersive course experience",
        "Real-time swing analysis with instant feedback",
        "Library of 150+ world-class courses",
        "Multiplayer tournaments and leagues"
      ],
      image: "https://emvwr2994ad.exactdn.com/wp-content/uploads/2022/02/golfsimulator-stockholm.jpg?strip=all&quality=77"
    },
    {
      title: "Coaching System Technology",
      content: "Revolutionary coaching tools for modern golfers:",
      features: [
        "3D motion capture for biomechanical analysis",
        "Pressure mat for weight distribution tracking",
        "Video analysis with slow-motion playback",
        "Mobile app for progress tracking",
        "AI-powered swing recommendations",
        "Virtual reality training modules"
      ],
      image: "https://images.pexels.com/photos/31212256/pexels-photo-31212256.jpeg?cs=srgb&dl=pexels-swingzone-swingzone-2150575315-31212256.jpg&fm=jpg"
    },
    {
      title: "Custom Equipment Technology",
      content: "State-of-the-art fitting technology for perfect equipment:",
      features: [
        "Launch monitor data integration",
        "Laser measurement for precise specifications",
        "3D body scanning for optimal fitting",
        "CAD design for custom club manufacturing",
        "Material science optimization",
        "Performance prediction algorithms"
      ],
      image: "https://images.unsplash.com/photo-1592659762303-90081d34b277?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    }
  ];

  /*
  const servicePackages = [
    {
      name: "Starter",
      price: "₹5,999",
      period: "per month",
      features: [
        "4 simulator sessions",
        "1 coaching session",
        "Basic equipment access",
        "Progress tracking",
        "Email support",
        "Monthly newsletter"
      ],
      best: false,
    },
    {
      name: "Progressive",
      price: "₹12,999",
      period: "per month",
      features: [
        "Unlimited simulator access",
        "4 coaching sessions",
        "Advanced equipment",
        "Tournament entry",
        "Priority booking",
        "Member lounge access",
        "Guest passes (2/month)",
        "Personal locker"
      ],
      best: true,
    },
    {
      name: "Elite",
      price: "₹24,999",
      period: "per month",
      features: [
        "All Progressive features",
        "Unlimited coaching",
        "Custom club fitting",
        "Personalized training plan",
        "Member events",
        "Unlimited guest passes",
        "24/7 facility access",
        "Professional swing analysis",
        "Annual equipment credit",
        "Concierge service"
      ],
      best: false,
    }
  ];
  */

  return (
    <>
      {/* Hero Section - Standardized with other pages */}
      <section className="services-hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-pattern"></div>

        <Container className="position-relative z-3 h-100">
          <Row className="h-100 align-items-center justify-content-center">
            <Col xs={12} lg={10} xl={8} className="text-center text-white">
              <h1 className="hero-title mb-4">Premium Golf Services</h1>
              <p className="hero-subtitle mb-5">
                Experience golf like never before with our comprehensive suite of services designed for every skill level
              </p>
              <div className="hero-cta d-flex flex-column flex-sm-row justify-content-center gap-3">
                <a href="#services" className="btn btn-gold-filled btn-lg px-4 px-md-5 py-3">
                  Book a Service
                </a>
                {/* <a href="#packages" className="btn btn-gold btn-lg px-4 px-md-5 py-3">
                  View Pricing
                </a> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Services Grid Section */}
      <section id="services" className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">Comprehensive Golf Solutions</h2>
              <p className="section-subtitle">
                From beginners to professionals, we offer everything you need to elevate your game in one premium location
              </p>
            </Col>
          </Row>

          <Row className="g-4 justify-content-center">
            {services.map((service, index) => (
              <Col xs={12} sm={6} lg={4} key={index}>
                <div className="service-card card-modern h-100 d-flex flex-column">
                  <div
                    className="service-img"
                    style={{ backgroundImage: `url(${service.image})` }}
                  >
                    <div className="service-img-overlay"></div>
                    <div
                      className="service-icon-badge"
                      style={{ backgroundColor: service.color }}
                    >
                      {service.icon}
                    </div>
                  </div>

                  <div className="service-content d-flex flex-column flex-grow-1 p-3 p-md-4">
                    <h3 className="h5 mb-2 service-title">{service.title}</h3>

                    <p className="service-description flex-grow-1 mb-3">
                      {service.description}
                    </p>

                    <div className="mb-4">
                      <h4 className="h6 mb-3 text-gold">Key Features:</h4>
                      <ul className="service-features">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="mb-2">
                            <span className="feature-check me-2">✓</span>
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="service-footer mt-auto pt-3 border-top">
                      {/* <button className="btn btn-gold w-100 mb-2">
                        Learn More
                      </button> */}
                      <p className="service-price small text-center text-muted mb-0">
                        Starting at ₹5,000/month
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* CTA Section */}
          <Row className="mt-5">
            <Col xs={12} className="text-center">
              <div className="newsletter-card">
                <div className="newsletter-icon mb-4">
                  ⛳
                </div>
                <h3 className="h2 mb-3 text-white">Ready to Elevate Your Game?</h3>
                <p className="newsletter-text mb-4">
                  Schedule a free consultation with our golf professionals and discover the perfect program for your needs.
                </p>
                <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                  <a href="/contact" className="btn btn-gold-filled btn-lg px-4 px-md-5 py-3">
                    Book Free Consultation
                  </a>
                  <a href="tel:+918610788265" className="btn btn-gold btn-lg px-4 px-md-5 py-3">
                    Call Now: +91 8610788265
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Technology Deep Dive Section */}
      <section className="section-padding bg-soft-sage">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">Cutting-Edge Technology</h2>
              <p className="section-subtitle">
                Experience the future of golf with our state-of-the-art technological innovations
              </p>
            </Col>
          </Row>

          <Row className="g-4 justify-content-center">
            {technologyDetails.map((tech, index) => (
              <Col xs={12} md={6} lg={4} key={index}>
                <div className="tech-card card-modern h-100 d-flex flex-column">
                  <div
                    className="tech-img"
                    style={{ backgroundImage: `url(${tech.image})` }}
                  ></div>

                  <div className="tech-content d-flex flex-column flex-grow-1 p-3 p-md-4">
                    <h3 className="h5 mb-2">{tech.title}</h3>

                    <p className="tech-description mb-3">
                      {tech.content}
                    </p>

                    <div className="mb-4">
                      <ul className="tech-features">
                        {tech.features.map((feature, idx) => (
                          <li key={idx} className="mb-2">
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <button className="btn btn-gold mt-auto">
                      Explore Technology
                    </button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* FAQ Accordion */}
          <Row className="mt-5">
            <Col xs={12} lg={10} className="mx-auto">
              <div className="faq-section card-modern p-4 p-md-5">
                <h3 className="h4 text-center mb-4 text-green">Frequently Asked Questions</h3>

                <Accordion flush>
                  {[
                    {
                      question: "What makes your golf academy different from others?",
                      answer: "Our academy uses a systematic coaching approach that moves away from traditional 'assembly line' training. We combine personalized coaching with cutting-edge technology, including 3D motion capture and AI-powered swing analysis, ensuring each golfer receives tailored training based on their unique biomechanics and goals."
                    },
                    {
                      question: "How accurate are your golf simulators?",
                      answer: "Our simulators use high-speed cameras and infrared sensors with millimeter accuracy. They track over 20 data points including ball speed, launch angle, spin rate, and club path. The technology is so precise that many professional golfers use similar systems for their training."
                    },
                    {
                      question: "Do you offer custom club fitting for beginners?",
                      answer: "Absolutely! In fact, we recommend custom fitting for golfers of all levels. Properly fitted clubs can significantly improve your game and prevent injuries. Our fitting process includes 3D body scanning, launch monitor data analysis, and expert consultation to ensure perfect equipment match."
                    },
                    {
                      question: "What membership options do you offer?",
                      answer: "We offer flexible membership tiers ranging from basic simulator access to premium packages including unlimited coaching, priority booking, and exclusive member events. Each tier is designed to meet different needs and budgets, with options for individuals, families, and corporate groups."
                    }
                  ].map((faq, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index} className="border-0 mb-2">
                      <Accordion.Header className="accordion-button-custom px-3 py-3">
                        {faq.question}
                      </Accordion.Header>
                      <Accordion.Body className="px-3 py-3 text-muted">
                        {faq.answer}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Service Packages Section removed to avoid rendering package pricing */}0

      {/* CSS Styles */}
      <style jsx>{`
        /* Hero Section - Standardized with other pages */
        .services-hero-section {
          height: 70vh;
          min-height: 600px;
          background: linear-gradient(rgba(31, 61, 43, 0.6), rgba(31, 61, 43, 0.75)), 
                     url('https://plus.unsplash.com/premium_photo-1661362222640-c262dad02bab?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D') center/cover no-repeat;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding-top: 80px;
        }
        
        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(180deg, rgba(31, 61, 43, 0.5) 0%, rgba(31, 61, 43, 0.7) 100%);
          z-index: 1;
        }
        
        .hero-pattern {
          position: absolute;̥
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: radial-gradient(circle at center, rgba(181, 154, 90, 0.1) 0%, transparent 70%);
          animation: pulse 4s ease-in-out infinite;
          z-index: 1;
        }
        
        .hero-title {
          font-size: clamp(2rem, 5vw, 3.5rem);
          color: #B59A5A;
          font-weight: 600;
          text-shadow: 0 2px 4px rgba(0,0,0,0.3);
          position: relative;
          z-index: 2;
          line-height: 1.2;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }
        
        .hero-subtitle {
          font-size: clamp(1rem, 2.5vw, 1.5rem);
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.95);
          text-shadow: 0 1px 3px rgba(0,0,0,0.3);
          position: relative;
          z-index: 2;
          margin-bottom: 2.5rem;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 400;
        }
        
        .hero-cta {
          position: relative;
          z-index: 2;
        }
        
        /* Button Styles - Consistent with other pages */
        .btn-gold-filled {
          background-color: #B59A5A;
          color: #1F3D2B;
          border: none;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          white-space: nowrap;
        }
        
        .btn-gold-filled:hover {
          background-color: #d4b56e;
          color: #1F3D2B;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
        }
        
        .btn-gold {
          background-color: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(5px);
          color: #B59A5A;
          border: 2px solid #B59A5A;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          white-space: nowrap;
        }
        
        .btn-gold:hover {
          background-color: rgba(181, 154, 90, 0.2);
          color: #d4b56e;
          border-color: #d4b56e;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
        }
        
        /* Section Styles */
        .section-padding {
          padding: clamp(3rem, 6vw, 5rem) 0;
        }
        
        .section-title {
          font-size: clamp(1.75rem, 4vw, 2.5rem);
          color: #1F3D2B;
          font-weight: 600;
          margin-bottom: 1rem;
          line-height: 1.2;
          font-family: 'Playfair Display', serif;
        }
        
        .section-subtitle {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 400;
        }
        
        /* Service Cards */
        .service-card {
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
        }
        0
        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        }
        
        .service-img {
          height: clamp(200px, 30vw, 250px);
          width: 100%;
          background-size: cover;
          background-position: center;
          position: relative;
        }
        
        .service-img-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to bottom, transparent 60%, rgba(0,0,0,0.7) 100%);
        }
        
        .service-icon-badge {
          position: absolute;
          top: 1rem;
          right: 1rem;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: white;
          box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        }
        
        .service-title {
          color: #1F3D2B;
          font-weight: 600;
          font-size: clamp(1rem, 1.8vw, 1.25rem);
          font-family: 'Playfair Display', serif;
        }
        
        .service-card:hover .service-title {
          color: #B59A5A;
          transition: color 0.3s ease;
        }
        
        .service-description {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.5;
        }
        
        .service-features {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .service-features li {
          margin-bottom: 0.5rem;
          color: #666;
          font-size: clamp(0.85rem, 1.5vw, 0.95rem);
          line-height: 1.4;
        }
        
        .feature-check {
          color: #B59A5A;
          font-weight: 600;
        }
        
        .service-footer {
          border-top: 1px solid rgba(31, 61, 43, 0.1);
        }
        
        .service-price {
          font-size: clamp(0.8rem, 1.5vw, 0.9rem);
        }
        
        /* Newsletter Card - Consistent with other pages */
        .newsletter-card {
          background: linear-gradient(135deg, #1F3D2B 0%, #2a4d3b 100%);
          color: white;
          padding: clamp(2rem, 4vw, 3rem);
          border-radius: 15px;
          width: 100%;
        }
        
        .newsletter-icon {
          width: clamp(60px, 10vw, 80px);
          height: clamp(60px, 10vw, 80px);
          background-color: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.5rem, 3vw, 2rem);
          margin: 0 auto 1.5rem;
        }
        
        .newsletter-text {
          opacity: 0.9;
          font-size: clamp(0.9rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          margin-bottom: 2rem;
          font-weight: 400;
        }
        
        /* Tech Cards */
        .tech-card {
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
        }
        
        .tech-card:hover {
          transform: translateY(-5px);
        }
        
        .tech-img {
          height: clamp(180px, 25vw, 220px);
          width: 100%;
          background-size: cover;
          background-position: center;
        }
        
        .tech-content {
          flex: 1;
        }
        
        .tech-description {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.5;
        }
        
        .tech-features {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .tech-features li {
          margin-bottom: 0.5rem;
          color: #666;
          font-size: clamp(0.85rem, 1.5vw, 0.95rem);
          line-height: 1.4;
        }
        
        /* FAQ Section */
        .faq-section {
          background: white;
          border-radius: 12px;
        }
        
        .accordion-button-custom {
          background-color: transparent !important;
          color: #1F3D2B !important;
          font-size: 1rem;
          padding: 1.5rem 0;
          border: none !important;
          box-shadow: none !important;
          font-weight: 500;
        }
        
        .accordion-button-custom:not(.collapsed) {
          color: #B59A5A !important;
        }
        
        /* Package Cards */
        .package-card {
          position: relative;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
          border: 1px solid rgba(31, 61, 43, 0.1);
        }
        
        .package-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        }
        
        .most-popular {
          border: 2px solid #B59A5A;
          box-shadow: 0 10px 30px rgba(181, 154, 90, 0.15);
        }
        
        .popular-badge {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          text-align: center;
          padding: 0.5rem;
          background: linear-gradient(90deg, #B59A5A 0%, #d4af37 50%, #B59A5A 100%);
          color: white;
          font-weight: 700;
          font-size: clamp(0.7rem, 1.5vw, 0.85rem);
          letter-spacing: 1px;
          text-transform: uppercase;
          z-index: 2;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .package-header {
          background: rgba(31, 61, 43, 0.02);
          border-bottom: 1px solid rgba(31, 61, 43, 0.1);
        }
        
        .package-name {
          color: #1F3D2B;
          font-weight: 600;
          font-size: clamp(1.25rem, 2vw, 1.5rem);
        }
        
        .most-popular .package-name {
          color: #B59A5A;
        }
        
        .package-type {
          font-size: clamp(0.85rem, 1.5vw, 0.95rem);
        }
        
        .package-price {
          background: rgba(31, 61, 43, 0.03);
        }
        
        .package-amount {
          font-size: clamp(2rem, 4vw, 2.5rem);
          color: #1F3D2B;
          font-weight: 600;
        }
        
        .most-popular .package-amount {
          color: #B59A5A;
        }
        
        .package-period {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
        }
        
        .package-features-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .package-features-list li {
          margin-bottom: 0.75rem;
          color: #666;
          font-size: clamp(0.85rem, 1.5vw, 0.95rem);
          line-height: 1.4;
        }
        
        .feature-icon {
          color: #B59A5A;
          flex-shrink: 0;
          margin-top: 2px;
        }
        
        .package-cta {
          border-top: none;
        }
        
        .package-badge {
          display: inline-block;
          background: #B59A5A;
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }
        
        .package-comparison {
          background: rgba(255, 255, 255, 0.8);
          border: 1px solid rgba(181, 154, 90, 0.2);
        }
        
        .package-comparison span {
          font-size: clamp(0.85rem, 1.5vw, 0.95rem);
          color: #666;
        }
        
        /* Text Colors */
        .text-gold {
          color: #B59A5A;
        }
        
        .text-green {
          color: #1F3D2B;
        }
        
        .text-muted {
          color: #666;
        }
        
        /* Background Colors */
        .bg-soft-sage {
          background-color: #f0f7f3;
        }
        
        /* Animations */
        @keyframes pulse {
          0%, 100% {
            opacity: 0.1;
          }
          50% {
            opacity: 0.2;
          }
        }
        
        /* Responsive Button Sizes */
        .btn-lg {
          padding: clamp(10px, 2vw, 12px) clamp(20px, 3vw, 32px);
          font-size: clamp(0.9rem, 1.5vw, 1rem);
        }
        
        /* Responsive Grid Gaps */
        .g-4 {
          --bs-gutter-x: clamp(1rem, 2vw, 1.5rem);
          --bs-gutter-y: clamp(1rem, 2vw, 1.5rem);
        }
        
        /* ================= MOBILE RESPONSIVE FIXES ================= */
        
        /* Extra Small Devices - Mobile Phones */
        @media (max-width: 576px) {
          .services-hero-section {
            height: 65vh;
            min-height: 500px;
            padding-top: 100px;
          }
          
          .hero-title {
            margin-bottom: 1rem;
            font-size: 2.2rem;
          }
          
          .hero-subtitle {
            margin-bottom: 2rem;
            font-size: 1.1rem;
          }
          
          .hero-cta {
            flex-direction: column;
            gap: 1rem;
            margin-top: 20px;
          }
          
          .hero-cta .btn {
            width: 100%;
            padding: 14px 20px;
            font-size: 1rem;
          }
          
          .service-img {
            height: 200px;
          }
          
          .tech-img {
            height: 180px;
          }
          
          .service-icon-badge {
            width: 45px;
            height: 45px;
            font-size: 1.3rem;
          }
          
          .popular-badge {
            padding: 0.4rem;
            font-size: 0.7rem;
            height: 35px;
          }
          
          .package-header {
            padding-top: calc(1rem + 35px) !important;
          }
          
          .package-amount {
            font-size: 2rem;
          }
          
          .btn-lg {
            padding: 14px 20px;
          }
        }
        
        /* Small Devices - Larger Mobile Phones */
        @media (min-width: 577px) and (max-width: 768px) {
          .services-hero-section {
            height: 70vh;
            min-height: 550px;
            padding-top: 90px;
          }
          
          .hero-title {
            font-size: 2.8rem;
          }
          
          .hero-subtitle {
            font-size: 1.3rem;
          }
          
          .hero-cta {
            margin-top: 10px;
          }
          
          .service-img {
            height: 220px;
          }
          
          .tech-img {
            height: 200px;
          }
          
          .popular-badge {
            height: 38px;
          }
          
          .package-header {
            padding-top: calc(1.25rem + 38px) !important;
          }
        }
        
        /* Medium Devices - Tablets */
        @media (min-width: 769px) and (max-width: 992px) {
          .services-hero-section {
            height: 75vh;
            min-height: 600px;
            padding-top: 80px;
          }
          
          .service-img {
            height: 230px;
          }
          
          .tech-img {
            height: 210px;
          }
          
          .popular-badge {
            height: 40px;
          }
          
          .package-header {
            padding-top: calc(1.5rem + 40px) !important;
          }
        }
        
        /* Large Devices - Desktops */
        @media (min-width: 993px) and (max-width: 1199px) {
          .services-hero-section {
            height: 80vh;
            min-height: 650px;
            padding-top: 60px;
          }
          
          .service-img {
            height: 240px;
          }
          
          .popular-badge {
            height: 40px;
          }
          
          .package-header {
            padding-top: calc(1.5rem + 40px) !important;
          }
        }
        
        /* Very Large Screens */
        @media (min-width: 1200px) {
          .services-hero-section {
            height: 85vh;
            min-height: 700px;
            padding-top: 40px;
          }
          
          .popular-badge {
            height: 40px;
          }
          
          .package-header {
            padding-top: calc(1.5rem + 40px) !important;
          }
        }
        
        /* Landscape Orientation on Mobile */
        @media (max-height: 600px) and (orientation: landscape) {
          .services-hero-section {
            height: 100vh;
            min-height: 400px;
            padding-top: 80px;
          }
          
          .hero-title {
            font-size: 2rem;
            margin-bottom: 0.5rem;
          }
          
          .hero-subtitle {
            font-size: 1rem;
            margin-bottom: 1.5rem;
          }
          
          .service-img {
            height: 180px;
          }
          
          .tech-img {
            height: 160px;
          }
          
          .popular-badge {
            height: 35px;
            font-size: 0.65rem;
          }
          
          .package-header {
            padding-top: calc(1rem + 35px) !important;
          }
        }
        
        /* Accessibility: Focus states */
        button:focus,
        input:focus,
        a:focus {
          outline: 2px solid #B59A5A;
          outline-offset: 2px;
        }
        
        /* Print styles */
        @media print {
          .hero-cta,
          .newsletter-card,
          .package-cta {
            display: none !important;
          }
          
          .services-hero-section {
            padding-top: 0;
            height: auto;
            min-height: auto;
          }
        }
      `}</style>
    </>
  );
};

export default Services;0